/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import {
  getUserProfileLinkByBusinessLine,
  getUserProfileParentEntityID,
  getUserProfileServiceID,
  isObserver,
} from "utils/user_helper"
import { GP, GP_MERCHANT } from "constants/user"
import { storageHelper } from "utils/storage"
import { TFacets, FacetTypes } from "./types"

export const generateDefaultFacets = (): TFacets => {
  const userProfileLink = getUserProfileLinkByBusinessLine(GP_MERCHANT)
  const defaultMexUser = userProfileLink.user_profile_grab_id
  const defaultMexID = userProfileLink.link_entity_id

  // to support old account from merchant-central (no GP_MERCHANT data)
  const altUserProfileLink = getUserProfileLinkByBusinessLine(GP)
  const altMexUser = altUserProfileLink.user_profile_grab_id
  const altMexID = altUserProfileLink.link_entity_id

  const serviceID = getUserProfileServiceID()

  return {
    [FacetTypes.Country]: storageHelper.getUserCountry(),
    [FacetTypes.Merchant]:
      defaultMexID || altMexID || getUserProfileParentEntityID() || "",
    [FacetTypes.MexUser]: defaultMexUser || altMexUser || serviceID,
    [FacetTypes.MexMerchant]: defaultMexID || getUserProfileParentEntityID(),
  }
}

export const withObserverModeFacet = (facets: TFacets): TFacets => ({
  ...facets,
  ...(isObserver() && { [FacetTypes.Mode]: "observer" }),
})
